import _ from 'underscore';
import Backbone from 'backbone';

var Base_View = function(options) {
    for (var key in this.events) {
        if (!_.isFunction(this.events[key])) {
            this.events[key] = this.dom_handlers[this.events[key]];
        }
    }

    Backbone.View.call(this, options);
};

_.extend(Base_View.prototype, Backbone.View.prototype, {
    remove: function() {
        var _walk_through = function(views) {
            // remove sub views
            if (views && typeof views === 'object') {
                _.each(views, function(subview, key) {
                    if (subview.remove) {
                        subview.remove.call(subview);
                    } else {
                        _walk_through(subview);
                    }

                    views[key] = {};
                }, this);
            }
        };

        _walk_through(this.views);

        // remove view
        this.trigger('remove');
        Backbone.View.prototype.remove.call(this);

        return this;
    }
});

Base_View.extend = Backbone.View.extend;

export default Base_View;